export default {
    max: 'Ensure this value is less than or equal to {{max}}.',
    min: 'Ensure this value is greater than or equal to {{min}}.',
};
